<template>
    <button 
        :style="{ backgroundColor: buttonConfig.color }" 
        @click="props.onClick" 
        class="session-action-button"
        :aria-labelledby="props.label"
        @keydown="() => handleKeyPress"
        >
        <img v-if="buttonConfig.image" 
            :src="buttonConfig.image" 
            alt="button icon" 
            class="button-image" 
            role="presentation"    
        />
        <span class="button-text">{{ buttonConfig.text }}</span>
    </button>
</template>

<script setup lang="ts">

import { computed } from 'vue';
import MicOutlineIcon from "../../assets/images/MicOutlineIcon.svg"
import UploadIcon from "../../assets/images/Upload-black.svg";
import FolderIcon from "../../assets/images/FolderDarkIcon.svg"

const props = defineProps<{
    type: 'record' | 'upload' | 'newfolder',
    onClick: () => void,
    label: string,
}>()

const handleKeyPress = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
        event.preventDefault();
        props.onClick();
        (event.target as HTMLElement).blur();
    }
}

const buttonConfig = computed(() => {
    switch (props.type) {
        case 'record':
        return {
            text: 'Record',
            color: '#e7b2ef',
            image: MicOutlineIcon,
        }
        case 'upload':
        return {
            text: 'Upload',
            color: '#b8df94',
            image: UploadIcon
        }
        case 'newfolder':
        return {
            text: 'New Folder',
            color: '#a0c1f6',
            image: FolderIcon
        }
        default:
        return {
            text: 'Default',
            color: 'gray',
            image: ''
        }
    }
    })
</script>

<style lang="scss" scoped>
.session-action-button {
    width: 13.8rem;
    height: 8rem;
    flex-grow: 0;
    border-radius: 1.6rem;
    text-align: left;
    font-size: 1.8rem;
    font-family: $font-default;
    display: flex;
    flex-direction: column;
}

.session-action-button:focus-visible {
    box-shadow: 0 0 0 0.3rem rgba(255, 233, 254, 0.4);
    outline: solid 0.2rem rgba(255, 233, 254, 1);
    border: solid 0.1rem map-get($colours, accent-purple3);
}

.button-image {
    width: 2.4rem;
    height: 2.4rem;
    margin: 0.8rem 0 0.8rem 0;
}

.button-text {
    margin-left: 0.5rem;
}
</style>